import AbstractProvidedClass from "../../shared/AbstractProvidedClass";

export default class PolyHorizontalBorder extends AbstractProvidedClass {
    defaultTolerance = this.mobile ? 12 : 7;
    lineLength = 5;

    constructor(provider, parent, corner1, corner2) {
        super(provider);
        this.parent = parent;
        this.corner1 = corner1;
        this.corner2 = corner2;
    }

    display(g) {
        g.stroke(0);
        g.strokeWeight(1);
        g.color(0);
        for (let i = Math.min(this.corner1.currentX, this.corner2.currentX);
            i <= Math.max(this.corner1.currentX, this.corner2.currentX);
            i += (this.lineLength) * 2
        ) {
            g.line(
                i,
                this.corner1.currentY,
                i + this.lineLength,
                this.corner1.currentY,
            );
        }
    }

    hovered() {
        return this.currentMinX <= this.view.currentX
            && this.currentMaxX >= this.view.currentX
            && this.currentMinY <= this.view.currentY
            && this.currentMaxY >= this.view.currentY;
    }

    drag(dx, dy) {
        this.move(dx, dy);
    }

    move(dx, dy) {
        if (dy == 0) {
            return;
        }
        this.corner1.absY += dy;
        this.corner2.absY += dy;
        this.parent.center.absY += dy / 2;
        this.parent.coordinates.map(c => {
            c.absY = this.parent.absMinY + this.parent.absHeight * c.yRatio;
        })
        this.updateInputs();
        this.parent.row.updateImg();
    }

    mouseOver() {
        if (!this.hovered()) {
            return false;
        }

        this.cursor.resizeVertical();
        return true;
    }

    updateInputs() {
        let multiInput = this.getTab('info').input.multiInput;
        for (let i = 0; i < this.parent.length; i++) {
            let input = multiInput.getInput(i);
            input.value(this.parent.segmentLength(i));
        }
    }

    get absY() {
        return this.corner1.absY;
    }

    get currentMinY() {
        return this.corner1.currentY - this.tolerance;
    }

    get currentMaxY() {
        return this.corner1.currentY + this.tolerance;
    }

    get currentMinX() {
        return Math.min(this.corner1.currentX, this.corner2.currentX);
    }

    get currentMaxX() {
        return Math.max(this.corner1.currentX, this.corner2.currentX);
    }

    get tolerance() {
        return Math.min(this.defaultTolerance, this.parent.currentHeight / 10)
    }
}
